import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ArrowLeft, ArrowRight } from "lucide-react";
import { TESTIMONIALS, IMAGES } from "@/lib/data";

export const Testimonials = () => {
  const [i, setI] = useState(0);
  const active = TESTIMONIALS[i];
  const prev = () => setI((v) => (v - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setI((v) => (v + 1) % TESTIMONIALS.length);

  return (
    <section
      id="testimonials"
      className="relative py-28 lg:py-40 overflow-hidden border-y border-border"
      data-testid="testimonials-section"
    >
      <div className="absolute inset-0">
        <img
          src={IMAGES.produce}
          alt=""
          className="w-full h-full object-cover opacity-[0.08]"
        />
        <div className="absolute inset-0 bg-background/40" />
      </div>

      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <p className="overline text-accent mb-10">04 / Reviews · 4.6 ★ from 88+</p>
        <Quote className="mx-auto text-accent mb-8" size={40} strokeWidth={1.2} />

        <div className="min-h-[240px] sm:min-h-[200px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid="testimonial-quote"
            >
              <p className="font-display text-3xl sm:text-5xl leading-tight tracking-tight text-foreground">
                “{active.quote}”
              </p>
              <footer className="mt-10">
                <span className="block font-mono-label text-sm uppercase tracking-widest text-foreground">
                  {active.name}
                </span>
                <span className="block mt-1 text-sm text-muted-foreground">
                  {active.detail}
                </span>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-12 flex items-center justify-center gap-6">
          <button
            onClick={prev}
            className="w-12 h-12 rounded-full border border-foreground/25 flex items-center justify-center hover:bg-foreground hover:text-primary-foreground transition-colors duration-300"
            data-testid="testimonial-prev"
            aria-label="Previous"
          >
            <ArrowLeft size={18} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  idx === i ? "w-8 bg-accent" : "w-2.5 bg-foreground/20"
                }`}
                data-testid={`testimonial-dot-${idx}`}
                aria-label={`Go to review ${idx + 1}`}
              />
            ))}
          </div>
          <button
            onClick={next}
            className="w-12 h-12 rounded-full border border-foreground/25 flex items-center justify-center hover:bg-foreground hover:text-primary-foreground transition-colors duration-300"
            data-testid="testimonial-next"
            aria-label="Next"
          >
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};
